(ns frontend.ui.component.lp-portal.report-list-header.view
  (:require
   [common.util :as cu]
   [frontend.ui.component.lp-portal.report-list-header.style :as style]
   [herb.core :refer [<class]]
   [re-frame.core :as rf]
   [frontend.lp-portal.sub :as portal-sub]))

(defn sort-menu
  [sorted-direction]
  [:div
   {:class (<class style/sort-menu)}
   (cond (= sorted-direction "ASC") [:i.fad.fa-sort-up]
         (= sorted-direction "DESC") [:i.fad.fa-sort-down]
         :else
         [:i.fad.fa-sort])])

(defn cell
  [{:keys [weight sort-keys sort-order on-sort-order-change min-screen-width-visible commitment-count]} &
   children]
  (let [sorted-column? (= sort-keys (:keys sort-order))
        tenant @(rf/subscribe [::portal-sub/tenant])
        tenant-name (:tenant/name tenant)
        capman? (some #{(cu/str-trim-lcase tenant-name)} ["capman"])
        sortable? (seq sort-keys)]
    [:div
     {:class    (<class
                 (fn []
                   (with-meta
                     (style/cell sortable?)
                     {:media {{:screen :only :max-width :991px}
                              {:font-size   :10px
                               :line-height :10px}
                              {:screen :only :max-width (str (or min-screen-width-visible 0) "px")}
                              {:display :none}}})))
      :on-click (fn []
                  (when sortable?
                   (on-sort-order-change {:keys      sort-keys
                                          :direction (if (and sorted-column?
                                                              (= "DESC" (:direction sort-order)))
                                                       "ASC"
                                                       "DESC")})))
      :style    (merge {:flex weight}
                       (when-not sort-keys
                         {:margin-right :0px
                          :padding-left :0px}))}
     [:span
      {:class (<class style/cell-text)}
      children]
     (when (and sort-keys (or (> commitment-count 1) capman?))
       [sort-menu
        (when sorted-column?
          (:direction sort-order))])]))

(defn name-cell
  [{:keys [weight sort-keys sort-order on-sort-order-change commitment-count]} & children]
  (let [sorted-column? (= sort-keys (:keys sort-order))
        tenant @(rf/subscribe [::portal-sub/tenant])
        tenant-name (:tenant/name tenant)
        capman? (some #{(cu/str-trim-lcase tenant-name)} ["capman"])]
    [:div
     {:class    (<class style/name-cell)
      :on-click (fn []
                  (on-sort-order-change {:keys      sort-keys
                                         :direction (if (and sorted-column?
                                                             (= "DESC" (:direction sort-order)))
                                                      "ASC"
                                                      "DESC")}))
      :style    {:flex weight}}
     [:div
      {:style {:padding-left :15px}}
      (->> children
           (map (fn [c]
                  ^{:key (:key c)}
                  c))
           (doall))]
     (when (or (> commitment-count 1) capman?)
       [sort-menu
        (when sorted-column?
          (:direction sort-order))])]))

(defn report-list-header
  [{:keys [on-sort-order-change sort-order commitment-count items]}]
  [:div
   {:class (<class style/container)}
   [name-cell
    (merge (select-keys (first items) [:weight :sort-keys])
           {:on-sort-order-change on-sort-order-change
            :sort-order           sort-order
            :commitment-count     commitment-count})
    (->> items
         (first)
         :children)]
   (->> items
        (rest)
        (remove nil?)
        (map (fn [item]
               ^{:key (str "report-list-header-cell-" (:sort-keys item))}
               [cell
                (merge (select-keys item [:weight :sort-keys :min-screen-width-visible])
                       {:on-sort-order-change on-sort-order-change
                        :sort-order           sort-order
                        :commitment-count     commitment-count})
                (:children item)])))])
